/*
  NOTE: This is the global export file for rxjs v6 and higher.
 */
/* rxjs */
export * from '../index';
/* rxjs.operators */
import * as _operators from '../operators/index';
export var operators = _operators;
/* rxjs.testing */
import * as _testing from '../testing/index';
export var testing = _testing;
/* rxjs.ajax */
import * as _ajax from '../ajax/index';
export var ajax = _ajax;
/* rxjs.webSocket */
import * as _webSocket from '../webSocket/index';
export var webSocket = _webSocket;
//# sourceMappingURL=umd.js.map